import React from "react";

const ASIDE_IMAGES = ["bg_1.jpg", "bg_2.jpg", "bg_3.jpg"];

export const AsideImage = () => {
  const img = ASIDE_IMAGES[Math.floor(Math.random() * ASIDE_IMAGES.length)];
  return <img src={`/img/${img}`} alt="illuminate" />;
};
